export const SELLER_ORDERS_WS_NAMESPACE = '/seller-orders';
export const SELLER_ORDERS_WS_PATH = '/api/ws';

export const SELLER_ORDERS_EVENTS = {
  orderNew: 'order:new',
  orderCanceled: 'order:canceled',
  orderDostavista: 'order:dostavista',
  notificationNew: 'notification:new',
} as const;

export type SellerNewOrderPayload = {
  orderId: number;
  orderNumber: string;
  pickupPointId: number | null;
  totalAmount: number;
  status: string;
};

export type SellerOrderCanceledPayload = {
  orderId: number;
  orderNumber: string;
  pickupPointId: number | null;
  reason: 'client';
};

export type SellerOrderDostavistaPayload = {
  orderId: number;
  orderNumber: string;
  pickupPointId: number | null;
  kind: 'canceled' | 'search_again';
};

export type SellerNotificationNewPayload = {
  id: number;
  title: string;
  body: string | null;
  category: string;
  data?: Record<string, unknown> | null;
};
